module.exports = __webpack_public_path__ + "img/10.67788fa9.png";